// extracted by mini-css-extract-plugin
export default {"container":"PropertyPageSimmilarProperties_container__UuxUC","title":"PropertyPageSimmilarProperties_title__3p2Ei"};